<template>
  <mdb-container
    fluid
    v-bind:style="{ fontFamily: 'OpenSans-Regular', fontSize: '12px' }"
  >
    <!--Section: Intro-->
    <mdb-row>
      <mdb-col>
        <h2 class="mt-lg-4 mb-1 pb-1" style="font-family: OpenSans-bold">
          <strong>Dispositivos</strong>
        </h2>
      </mdb-col>
      <mdb-col>
        <div class="mt-lg-4 mb-1 pb-1">
          <mdb-form-inline>
            <input
              v-on:keydown.enter.prevent="'';"
              class="mr-sm-2 filter-input"
              type="text"
              v-model="search"
              style="width: 100% !important; border: 0px !important"
              placeholder="Buscar dispositivo por Nombre, estatus, Zona/Dirección"
            />
          </mdb-form-inline>
        </div>
      </mdb-col>
    </mdb-row>
    <!--Section: Main panel-->
    <section class="my-5">
      <!--Card-->
      <mdb-card cascade>
        <!--Section: Table-->
        <!--Top Table UI-->
        <div class="card card-cascade narrower z-depth-0">
          <!--Card image-->
          <div
            class="view view-cascade narrower py-2 mx-4 mb-3 d-flex justify-content-between align-items-center"
            style="
              margin-top: -2.25rem;
              background-color: #67a3cf;
              position: static;
            "
          >
            <div class="text-left">
              <mdb-tooltip
                material
                trigger="hover"
                :options="{ placement: 'top' }"
              >
                <span slot="tip">Alta dispositivo</span>
                <a slot="reference" @click="openModal">
                  <img
                    alt="nuevo dispositivo"
                    class="mt-0"
                    :src="imgServer + 'apps/myfrac/admin/assets/Crear_BTN@3x.png'"
                    style="
                      margin-left: 1rem;
                      width: 31.2px;
                      height: 31.2px;
                      object-fit: contain;"
                  />
                </a>
              </mdb-tooltip>
            </div>

            <span
              class="white-text"
              style="
                font-family: OpenSans-Bold;
                font-size: 16px;
                display: table;
                margin: 0 auto;
              "
              >Dispositivos registrados</span
            >

            <div
              class="text-right"
              style="margin-top: -10px; display: flex; float: right"
            ></div>
          </div>
          <mdb-container>
            <div class="offset">
              <mdb-tbl class="table-st">
                <mdb-tbl-head responsive>
                  <tr>
                    <th class="text-center">Estatus</th>
                    <th class="text-center">Nombre</th>
                    <th class="text-center">Tipo</th>
                    <th class="text-center">Ubicación</th>
                    <th class="text-center">Acciones</th>
                  </tr>
                </mdb-tbl-head>

                <mdb-tbl-body>
                  <tr v-for="(item, index) in displayedPost" v-bind:key="index">
                    <td class="text-center" v-if="item.status == 'INACTIVE'">
                      <mdb-icon
                        icon="circle"
                        class="pr-4"
                        style="color: red; margin-left: 1rem"
                      />
                    </td>
                    <td class="text-center" v-else>
                      <mdb-icon
           
                        icon="circle"
                        class="pr-4"
                        style="color: green; margin-left: 1rem"
                      />
                    </td>
                    <td class="text-center" style="width: 1rem">
                      {{ item.name }}
                    </td>
                    <td class="text-center" v-if="item.deviceType == 'BOOTH'">
                      Caseta
                    </td>
                    <td
                      class="text-center"
                      v-else-if="item.deviceType == 'HOSTESS'"
                    >
                      Hostess
                    </td>
                    <td class="text-center" v-else>Escáner</td>
                    <td class="text-center" v-if="item.scannerType == 'STREET'">
                      {{'Calle: '+item.street.name+', Zona: '+item.street.testZone.name}}
                    </td>
                    <td class="text-center" v-else-if="item.scannerType == 'ZONE'">
                         {{'Zona: '+item.zone.name}}
                    </td>
                    <td class="text-center" v-else-if="item.scannerType == 'HOUSE'">
                         {{'Calle: '+item.street.name+', Número '+item.number+', Zona: '+item.street.testZone.name}}
                    </td>
                    <td class="text-center"  v-else>DISPOSITIVO SIN UBICACIÓN</td>

                    <td class="text-center">
                      <div>
                        <mdb-tooltip
                         
                          material
                          trigger="hover"
                          :options="{ placement: 'top' }"
                        >
                          <span slot="tip">Editar</span>
                          <mdb-btn
                            slot="reference"
                            outline="white"
                            rounded
                            size="sm"
                            class="px-2 button_background"
                            @click="getSingleDevice(item.uuid)"
                          >
                            <mdb-icon icon="edit" class="mt-0" />
                          </mdb-btn>
                        </mdb-tooltip>
                        <mdb-tooltip
                          v-if="item.status == 'INACTIVE'"
                          material
                          trigger="hover"
                          :options="{ placement: 'top' }"
                        >
                          <span slot="tip">Vincular</span>

                          <mdb-btn
                            slot="reference"
                            outline="white"
                            rounded
                            size="sm"
                            class="px-2 ml-2 button_background"
                            style="width: 2rem"
                            @click="showQrCode(item.code, item.code)"
                          >
                            <mdb-icon icon="qrcode" />
                          </mdb-btn>
                        </mdb-tooltip>
                        <mdb-tooltip
                          v-if="item.status == 'INACTIVE'"
                          material
                          trigger="hover"
                          :options="{ placement: 'top' }"
                        >
                          <span slot="tip">Eliminar</span>
                          <mdb-btn
                            slot="reference"
                            outline="white"
                            rounded
                            size="sm"
                            class="px-2 ml-2 button_background"
                            style="width: 2rem"
                            @click="deleteDevice(item.uuid, item.name)"
                          >
                            <mdb-icon icon="trash" />
                          </mdb-btn>
                        </mdb-tooltip>
                        <mdb-tooltip
                          v-else
                          material
                          trigger="hover"
                          :options="{ placement: 'top' }"
                        >
                          <span slot="tip">Desvincular</span>

                          <mdb-btn
                            slot="reference"
                            outline="white"
                            rounded
                            size="sm"
                            class="px-2 ml-2 button_background"
                            style="width: 2rem"
                            @click="unLinkDevice(item.deviceToken)"
                          >
                            <mdb-icon icon="unlink" />
                          </mdb-btn>
                        </mdb-tooltip>
                      </div>
                    </td>
                  </tr>
                </mdb-tbl-body>
              </mdb-tbl>

              <!-- Componente de Paginación -->
              <Pagination :currentPage="page" :totalPages="numberOfPages" @page-change="goToPage" />
            
            </div>
          </mdb-container>
        </div>

        <!--Section: Table-->
      </mdb-card>
      <!--/.Card-->
    </section>
    <!--Section: Main panel-->

    <mdb-modal :show="showModal" @close="closeModal" :size="'lg'">
      <mdb-modal-header class="text-center modal-header-style">
        <mdb-modal-title tag="span" class style="color: #ffffff"
          >{{ TitleModal }} dispositivo</mdb-modal-title
        >
      </mdb-modal-header>
      <mdb-modal-body class="mx-3">
        <form
          id="gateForm"
          class="needs-validation"
          style="display: flex"
          novalidate
          @submit="submitForm"
        >
          <mdb-col>
            <mdb-row>
              <mdb-col md="6">
                <mdb-row>
                  <label
                    for="nameGate"
                    style="font-family: OpenSans-Semibold; font-size: 12px"
                    >Nombre</label
                  >
                  <input
                    type="text"
                    class="form-control text-input"
                    id="nameGate"
                    required
                    v-model="deviceName"
                    style="height: 37px; margin-top: 10px; font-size: 12px"
                  />
                  <div class="valid-feedback">Correcto</div>
                  <div class="invalid-feedback">
                    Asigna un nombre al dispositivo
                  </div>
                </mdb-row>
              </mdb-col>
              <mdb-col md="6">
                <label
                  for="radiosDevices"
                  style="font-family: OpenSans-Semibold; font-size: 12px"
                  >Selecciona el tipo de dispositivo</label
                >
                <mdb-row id="radiosDevices" class="mt-3">
                  <mdb-col md="3">
                    <mdb-input
                      type="radio"
                      id="option4-1"
                      name="groupOfMaterialRadios"
                      radioValue="BOOTH"
                      v-model="deviceType"
                      label="Caseta"
                    />
                  </mdb-col>
                  <mdb-col
                    md="3"
                    v-if="
                      whoami.frac == 'Club Tres Marias'
                    "
                  >
                    <mdb-input
                      type="radio"
                      id="option4-2"
                      name="groupOfMaterialRadios"
                      radioValue="HOSTESS"
                      v-model="deviceType"
                      label="Hostess"
                    />
                  </mdb-col>
                  <mdb-col md="3">
                    <mdb-input
                      type="radio"
                      id="option4-3"
                      name="groupOfMaterialRadios"
                      radioValue="SCANNER"
                      v-model="deviceType"
                      label="Escáner"
                    />
                  </mdb-col>
                </mdb-row>
              </mdb-col>
            </mdb-row>
            <mdb-row v-if="deviceType == 'SCANNER'" class="mt-3">
              <mdb-col md="6">
                <label
                  for="subTypeDevices"
                  style="font-family: OpenSans-Semibold; font-size: 12px"
                  >Selecciona el subtipo:</label
                >
                <mdb-row id="subTypeDevices">
                  <mdb-col md="4">
                    <mdb-input
                      type="radio"
                      id="subtype-1"
                      name="groupOfSubType"
                      radioValue="BARRERA"
                      v-model="deviceSubType"
                      label="Barrera"
                    />
                  </mdb-col>
                  <mdb-col md="4">
                    <mdb-input
                      type="radio"
                      id="subtype-2"
                      name="groupOfSubType"
                      radioValue="COTO"
                      v-model="deviceSubType"
                      label="Coto"
                    />
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="4">
                    <mdb-input
                      type="radio"
                      id="subtype-3"
                      name="groupOfSubType"
                      radioValue="CASA"
                      v-model="deviceSubType"
                      label="Casa"
                    />
                  </mdb-col>
                  <mdb-col md="4">
                    <mdb-input
                      type="radio"
                      id="subtype-4"
                      name="groupOfSubType"
                      radioValue="COMMONAREA"
                      v-model="deviceSubType"
                      label="Área común"
                    />
                  </mdb-col>
                </mdb-row>
              </mdb-col>
              <mdb-col md="6">
                <div class="form-group">
                  <label
                    for="ubicacion"
                    style="font-family: OpenSans-Semibold; font-size: 12px"
                    >Tipo de Ubicación</label
                  >
                  <select
                    name="ubicacion"
                    id="ubicacion"
                    v-model="ubicacionType"
                    class="browser-default form-control text-input"
                    style="height: 37px; margin-top: 10px; font-size: 12px"
                  >
                    <option value="HOUSE">Dirección</option>
                    <option value="STREET">Calle</option>
                    <option value="ZONE">Zona</option>
                  </select>
                </div>
              </mdb-col>
            </mdb-row>
            <mdb-row v-if="deviceType == 'SCANNER'" class="mt-3">
              <mdb-col md="6">
                <label
                  for="zonaSelect"
                  style="font-family: OpenSans-Semibold; font-size: 12px"
                  >Selecciona una zona</label
                >
                <model-select
                  id="zonaSelect"
                  :options="zonesList"
                  v-model="zoneModel"
                  :isError="zoneValid"
                  class=""
                  style="height: 37px; margin-top: 10px; font-size: 12px"
                  placeholder="selecciona una zona"
                ></model-select>
              </mdb-col>
              <mdb-col v-if="ubicacionType != 'ZONE'" md="6">
                <label
                  for="streetSelect"
                  style="font-family: OpenSans-Semibold; font-size: 12px"
                  >Selecciona una calle</label
                >
                <model-select
                  id="streetSelect"
                  :options="streetList"
                  v-model="streetModel"
                  :isError="streetValid"
                  class=""
                  style="height: 37px; margin-top: 10px; font-size: 12px"
                  placeholder="selecciona una calle"
                ></model-select>
              </mdb-col>
            </mdb-row>
            <mdb-row
              v-if="ubicacionType == 'HOUSE' && deviceType == 'SCANNER'"
              class="mt-3"
            >
              <mdb-col md="6">
                <label
                  for="num"
                  style="font-family: OpenSans-Semibold; font-size: 12px"
                  >Número</label
                >
                <input
                  type="number"
                  class="form-control text-input"
                  id="num"
                  v-model="houseNumber"
                  required
                  style="height: 37px; margin-top: 10px; font-size: 12px"
                />
              </mdb-col>
            </mdb-row>
            <mdb-row v-if="deviceType == 'SCANNER'" class="mt-3">
              <mdb-col md="6">
                <mdb-row>
                  <mdb-col>
                    <label
                      for="idType-1"
                      style="font-family: OpenSans-Semibold; font-size: 12px"
                      >Tipo de lectura</label
                    >
                    <mdb-input
                      type="radio"
                      id="idType-1"
                      name="RadioScanners"
                      radioValue="IN"
                      v-model="lecturaType"
                      label="Ingreso"
                    />
                  </mdb-col>
                  <mdb-col>
                    <label
                      for="idType-3"
                      style="font-family: OpenSans-Semibold; font-size: 12px"
                    ></label>
                    <mdb-input
                      type="radio"
                      id="idType-3"
                      name="RadioScanners"
                      radioValue="OUT"
                      v-model="lecturaType"
                      label="Salida"
                    />
                  </mdb-col>
                </mdb-row>
              </mdb-col>
              <mdb-col v-if="lecturaType != 'OUT'" md="6">
                <label
                  for="ubicacion"
                  style="font-family: OpenSans-Semibold; font-size: 12px"
                  >Selecciona los dispositivos de su ruta</label
                >
                <multiselect
                  v-model="parentSelect"
                  placeholder="Selecciona los dispositivos de la ruta"
                  label="name"
                  track-by="value"
                  :options="parentDevices"
                  :multiple="true"
                  :taggable="true"
                ></multiselect>
              </mdb-col>
            </mdb-row>
            <mdb-row>
              <div
                class="text-right mb-1"
                style="display: flex; position: relative; float: right; margin-left: auto;"
              >
                <mdb-btn
                  color="color-prev"
                  class="btn-prev Rectngulo-14"
                  type="button"
                  @click="
                    showModal = false;
                    TitleModal = 'Registrar';"
                  >Cancelar</mdb-btn
                >
                <mdb-btn
                  v-if="TitleModal == 'Registrar'"
                  type="submit"
                  class="btn btn-next btn-color-next Rectngulo-14"
                  >Registrar</mdb-btn
                >
                <mdb-btn
                  v-else
                  type="submit"
                  class="btn btn-next btn-color-next Rectngulo-14"
                  >Actualizar</mdb-btn
                >
              </div>
            </mdb-row>
          </mdb-col>
        </form>
      </mdb-modal-body>
    </mdb-modal>
    <Loader v-show="isLoading"/>
  </mdb-container>
</template>

<script>
/* eslint-disable */
import Swal from "sweetalert2";
import Axios from "axios";
import Servers from "../../../server.js";
import { mapGetters, mapActions } from "vuex";
import { ModelSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";
import Pagination from "@/components/Pagination.vue";
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardImage,
  mdbCardHeader,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbCardUp,
  mdbCardAvatar,
  mdbCardGroup,
  mdbBtn,
  mdbDatePicker,
  mdbTooltip,
  mdbSimpleChart,
  mdbIcon,
  mdbFormInline,
  mdbBadge,

  mdbInput,
  
  mdbAvatar,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbTbl,
  mdbTblHead,
  mdbTblBody
} from "mdbvue";

export default {
  name: "Devices",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardUp,
    mdbCardAvatar,
    mdbCardGroup,
    mdbBtn,
    mdbDatePicker,
    mdbTooltip,
    mdbSimpleChart,
    mdbIcon,
    mdbFormInline,
    mdbBadge,
    mdbInput,
    mdbAvatar,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    ModelSelect,
    Multiselect,
    Pagination,
  },
  data() {
    return {
      isLoading: false,
      urlServer: Servers.serverApi,
      imgServer: Servers.serverImg,
      deviceList: [],
      page: 1,
      perPage: 15,
      pages: [],
      numberOfPages: 0,
      requestShow: false,
      showModal: false,
      search: null,
      deviceName: "",
      TitleModal: "Registrar",
      gate: [],
      deviceType: "BOOTH",
      deviceSubType: "BARRERA",
      deviceStatus: "INACTIVE",
      isForHostes: false,
      isForCaseta: true,
      isForScanner: false,
      devicesType: [
        {
          value: "Barrera",
          text: "Barrera"
        },
        {
          value: "Casa",
          text: "Casa"
        },
        {
          value: "Coto",
          text: "Coto"
        },
        {
          value: "Acomun",
          text: "Área comun"
        }
      ],
      ubicacionType: "ZONE",
      ubicacionError: false,
      scannerType: "",
      scannerTypeError: false,
      lecturaType: "IN",
      streetList: [],
      streetModel: {
        value: "",
        uuid: "",
        text: ""
      },
      streetValid: false,
      zonesList: [],
      zoneModel: {
        value: "",
        uuid: "",
        text: ""
      },
      zoneValid: false,
      parentDevices: [],
      houseNumber: "",
      parentSelect: [],
      deviceId: "",
    };
  },
  methods: {
    ...mapActions([
      "ZonesList",
      "StreetList",
      "getAllDevices",
      "getDeviceInfo",
      "postDevice",
      "getParentDevices",
      "editDevice"
    ]),
    openModal() {
      this.showModal = true;
      this.parentSelect = [];
      this.deviceName = "";
      this.streetModel = {
        value: "",
        uuid: "",
        text: ""
      };

      this.zoneModel = {
        value: "",
        uuid: "",
        text: ""
      };
      this.houseNumber = "";
    },
    closeModal() {
      this.deviceName = "";
      this.deviceId = "";
      this.showModal = false;
      this.TitleModal = "Registrar";
    },
    submitForm(event) {
      event.preventDefault();
      event.target.classList.add("was-validated");
      if (this.deviceName != "") {
        if (this.TitleModal == "Registrar") {
          this.createDevice();
        } else {
          this.putDevice();
        }
      }
    },
    async getParent(uuid) {
      try {
        let response = await this.getParentDevices(uuid);
        console.log(response.data.data);
        this.parentDevices = response.data.data.map(function(element) {
          return { name: element.name, value: element.uuid };
        });
      } catch (error) {
        console.log(error.response.data);
      }
    },
    async getDevices() {
      try {
        this.isLoading = true;
        let response = await this.getAllDevices();
        this.deviceList = response.data.data;
        this.numberOfPages = Math.ceil(this.deviceList.length / this.perPage);
      } catch (error) {
        console.log(error.response.data);
      } finally {
        this.isLoading = false
      }
    },
  
    async getSingleDevice(uuid) {
      try {
        let response = await this.getDeviceInfo(uuid);
        console.log(response.data.data)
        this.deviceName = response.data.data.name;
        this.deviceType = response.data.data.deviceType;
        this.deviceId = uuid;
        if (this.deviceType == "SCANNER") {
          this.lecturaType = response.data.data.scannerAccess;
          this.parentSelect = response.data.data.parents.map(function(element) {
            return { name: element.name, value: element.uuid };
          });
        
          this.ubicacionType = response.data.data.scannerType;
          if (this.ubicacionType == "ZONE") {
            this.deviceSubType = "BARRERA"
            this.zoneModel = {
              value: response.data.data.zone.idZone,
              uuid: response.data.data.zone.uuid,
              text: response.data.data.zone.name
            };
          }
          if (this.ubicacionType == "STREET" || this.ubicacionType == "HOUSE") {
              this.deviceSubType = "COTO"
            this.streetModel = {
              value: response.data.data.street.idStreet,
              uuid: response.data.data.street.uuid,
              text: response.data.data.street.name
            };
             this.zoneModel = {
              value: response.data.data.street.testZone.idZone,
              uuid: response.data.data.street.testZone.uuid,
              text: response.data.data.street.testZone.name
            };
          }
          if (this.ubicacionType == "HOUSE") {
              this.deviceSubType = "CASA"
            this.houseNumber = response.data.data.number;
          }
        }
      } catch (error) {
        console.log(error.response.data);
      }
      this.TitleModal = "Editar";
      this.showModal = true;
    },
    async putDevice(){
      
        let data = {}

       data.body = {
        name: this.deviceName,
        deviceType: this.deviceType
      };
      data.uuid = this.deviceId

      if (this.deviceType == "SCANNER") {
        let deviceSelected = this.parentSelect.map(function(element) {
          return { uuid: element.value };
        });
        data.body.scannerAccess = this.lecturaType;
        data.body.parents = deviceSelected;
        data.body.scannerType = this.ubicacionType;
        if (this.ubicacionType == "ZONE") {
          data.body.zone = { uuid: this.zoneModel.uuid };
        }
        if (this.streetModel.uuid != "") {
          data.body.street = { uuid: this.streetModel.uuid };
        }
        if (this.houseNumber != "") {
          data.body.number = this.houseNumber;
        }
      }

       try {
         let response = await this.editDevice(data)
         this.showMessageSucces("¡Dispositivo actualizado correctamente!");
       } catch (error) {
         let message = error.response.data.error_description ?? error.response.data.message;
         this.showMessageError("Error", message)
         
       }

    },
    // putDevice() {
    //   let aux = this;
    //   var data = {
    //     uuid: aux.gate.uuid,
    //     name: aux.deviceName,
    //     deviceType: aux.deviceType,
    //   };
    //   Axios.put(Servers.serverApi + "api/qrcodes/" + aux.gate.uuid, data, {
    //     responseType: "application/json",
    //     headers: {
    //       Authorization: "Bearer " + localStorage.getItem("access_token"),
    //     },
    //   })
    //     .then(function (response) {
    //       aux.showMessageSucces("¡Dispositivo actualizado correctamente!");
    //     })
    //     .catch((error) => {
    //       console.log(error.response.data);
    //     });
    // },
    // getTypeDevice(){

    //   if(this.isForHostes){
    //     return "HOSTESS"
    //   }
    //   if(this.isForScanner){
    //     return "SCANNER"
    //   }
    //   if(this.isForCaseta){
    //     return "BOOTH"
    //   }

    // },
    async createDevice() {
      let body = {
        name: this.deviceName,
        deviceType: this.deviceType
      };

      if (this.deviceType == "SCANNER") {
        let deviceSelected = this.parentSelect.map(function(element) {
          return { uuid: element.value };
        });
        body.scannerAccess = this.lecturaType;
        body.parents = deviceSelected;
        body.scannerType = this.ubicacionType;
        if (this.ubicacionType == "ZONE") {
          body.zone = { uuid: this.zoneModel.uuid };
        }
        if (this.streetModel.uuid != "") {
          body.street = { uuid: this.streetModel.uuid };
        }
        if (this.houseNumber != "") {
          body.number = this.houseNumber;
        }
      }
      console.log(body);
      try {
        let response = await this.postDevice(body);
        this.showMessageSucces("¡Dispositivo registrado correctamente!");
      } catch (error) {
        this.showMessageError("Error", error.response.data.message);
      }
    },
    // postDevice() {
    //   let aux = this;

    //   var data = {
    //     name: aux.deviceName,
    //     deviceType: aux.deviceType,
    //   };

    //   Axios.post(Servers.serverApi + "api/qrcodes", data, {
    //     responseType: "application/json",
    //     headers: {
    //       Authorization: "Bearer " + localStorage.getItem("access_token"),
    //     },
    //   })
    //     .then(function (response) {
    //       aux.showMessageSucces("¡Dispositivo registrado correctamente!");
    //     })
    //     .catch((error) => {
    //       console.log(error.response.data);
    //     });
    // },
    deleteDevice(uuid, name) {
      let aux = this;
      Swal.fire({
        title: "¿Seguro que deseas eliminar " + name + "?",
        text: "No podrás revetir esta acción",
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
        reverseButtons: true
      }).then(result => {
        if (result.value) {
          Axios.delete(Servers.serverApi + "api/devices/" + uuid, {
            responseType: "application/json",
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token")
            }
          })
            .then(function(response) {
              aux.showMessageSucces("¡Dispositivo eliminado correctamente!");
            })
            .catch(function(error) {
              console.log(error.response.data);
            });
        }
      });
    },
    setPages() {
      this.pages = [];
      for (let index = 1; index <= this.numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    paginate(wList) {
      this.numberOfPages = Math.ceil(wList.length / this.perPage);
      let page = this.page;
      let perPage = this.perPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      this.setPages();
      return wList.slice(from, to);
    },
    showMessageError: function(text, error) {
      Swal.fire({
        title: "<span style='font-size: 20px'>" + text + "</span>",
        html: "<span style='font-size: 12px'>" + error + "</span>",
        imageUrl: "../static/Cancel_icon.png",
        imageWidth: "22%",
        imageHeight: "auto",
        width: "30%",
        //confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () => {}
      });
    },
    showMessageSucces: function(text) {
      Swal.fire({
        title: "<span style='font-size: 20px;'>" + text + "</span>",
        html: "<span style='font-size: 12px;'></span>",
        type: "success",
        width: "30%",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () => {
          this.closeModal();
          this.getDevices();
          this.getParent("");
          //window.location.reload();
        }
      });
    },
    unLinkDevice(token) {
      Swal.fire({
        title: "¿Estás seguro de desvincular este dispositivo?",
        text: "Si desvinculas, el dispositivo no podrá usarse",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        reverseButtons: true
      }).then(result => {
        if (result.value) {
          this.desQrCode(token);
        }
      });
    },
    desQrCode(token) {
      let aux = this;
      Axios.put(Servers.serverApi + "api/devices/unlinkDevice/" + token, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      }).then(
        function(response) {
          aux.showMessageSucces("¡Dispositivo desvinculado correctamente!");
        },
        function(error) {
          aux.showMessageError("Error", error.response.data.error_description);
        }
      );
    },
    showQrCode(code, text) {
      console.log(code, text);
      Swal.fire({
        imageUrl:
          "https://api.qrserver.com/v1/create-qr-code/?size=200x200&color=23a7ed&data=" +
          code,
        imageHeight: 200,
        imageAlt: "" + code,
        title: "<span style='font-size: 20px;'>" + text + "</span>",
        width: "30%",
        confirmButtonText: "Aceptar",
        onOpen: () => {
          Swal.showLoading();
          setInterval(() => {
            Swal.hideLoading();
            Swal.confirmButtonClass = "btn btn-modal-accept";
          }, 1100);
        },
        onClose: () => {
          window.location.reload();
        }
      });
    },
    async getStreets(uuid) {
      let response = await this.StreetList(uuid);
      this.streetList = [];
      for (var i = 0; i < response.data.length; i++) {
        var temp = {
          value: response.data[i].idStreet,
          uuid: response.data[i].uuid,
          text: response.data[i].name
        };
        this.streetList.push(temp);
      }
    },
    goToPage(pageNumber) {
      this.page = pageNumber;
      localStorage.setItem('currentPage', pageNumber);
      this.getDevices(); // Llamada para actualizar los datos según la página seleccionada
    },
  },
  async mounted() {
    let response = await this.ZonesList();
    this.zoneList = [];
    for (var i = 0; i < response.data.length; i++) {
      var temp = {
        value: response.data[i].idZone,
        uuid: response.data[i].uuid,
        text: response.data[i].name
      };
      this.zonesList.push(temp);
    }
  },
  created() {
    //this.checkMe();
    this.search = localStorage.getItem('currentSearch') || null;
    this.page = parseInt(localStorage.getItem('currentPage')) || 1;
    this.getDevices();
    this.getParent("");
  },
  beforeRouteLeave(to, from, next) {
    localStorage.removeItem('currentSearch');
    localStorage.removeItem('currentPage'); // Limpiar la página actual cuando se cambie de ruta

    next();
  },
  watch: {
    deviceList() {
      this.setPages();
    },
    zoneModel(newZone) {
      this.zoneModel = newZone;
      if (newZone.value) {
        this.zoneValid = false;
        this.getStreets(newZone.uuid);
      } else {
        this.zoneValid = true;
      }
    },
    streetModel(newStreet) {
      this.streetModel = newStreet;
      if (newStreet.value) {
        this.streetValid = false;
      } else {
        this.streetValid = true;
      }
    },
    deviceSubType(val) {
      switch (val) {
        case "BARRERA":
          this.ubicacionType = "ZONE";
          break;
        case "COTO":
          this.ubicacionType = "STREET";
          break;
        case "CASA":
          this.ubicacionType = "HOUSE";
          break;
        case "COMMONAREA":
          this.ubicacionType = "ZONE";
          break;
        default:
          break;
      }
    },
    search() {
      this.page = 1;
      localStorage.setItem('currentSearch', this.search);
      localStorage.setItem('currentPage', this.page);
      this.getUsers();
      //this.currentTime = new Date().getTime();
    },
  },
  computed: {
    ...mapGetters({
      whoami: "getWhoAmi",
      device: "getDevice"
    }),
    displayedPost() {
      if (this.search) {
        // this.page = 1;
        this.page = parseInt(localStorage.getItem('currentPage')) || 1;
        return this.paginate(
          this.deviceList.filter(item => {
            return (
              item.name.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
            );
          })
        );
      } else return this.paginate(this.deviceList);
    }
  }
};
</script>

<style
  src="../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css"
></style>

<style scoped>
::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #fff;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #fff;
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #fff;
}

.table-st {
  border-collapse: collapse !important;
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
  margin-top: 0 !important;
}

.tooltip-p {
  position: relative;
  display: inline-block;
}

/* Tooltip text */
.tooltip-p .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: #555;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;

  /* Position the tooltip text */
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -60px;

  /* Fade in tooltip */
  opacity: 0;
  transition: opacity 0.3s;
}

/* Tooltip arrow */
.tooltip-p .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip-p:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}

.HeadBG {
  background-color: #f5f6fa;
  font-family: "OpenSans-Semibold" !important;
  color: #747474;
  font-size: 12px;
  text-align: center !important;
}

.table > tbody {
  text-align: center;
}

.Trazado-295 {
  width: auto;
  height: 35px;
  border: solid 1px #e8e9ec !important;
  background-color: #ffffff !important;
}

.filter-input {
  position: initial;
  margin-left: 0.5em;
  margin-right: 1rem;
  margin-top: 2rem;
  border-radius: 25px;
  height: 35px;
  padding-left: 35px;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-right: 10px;
  font-family: "OpenSans-Regular";
  font-size: 12px;
  color: #fff;
  background: url("../../../static/zoom_in.png") no-repeat scroll 12px 7px
    #67a3cf;
  background-size: 20px 20px;
}

.filter-input:focus {
  font-family: "OpenSans-Regular";
  font-size: 12px;
  color: #fff;
  background: url("../../../static/zoom_in.png") no-repeat scroll 12px 7px
    #67a3cf;
  background-size: 20px 20px;
}

.modal-header-style {
  height: 51.5px;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.08);
  background-color: #67a3cf;
}

.table > thead > tr > th {
  text-align: justify;
}

.table > tbody > tr > td {
  text-align: center !important;
}
</style>

<style></style>
